<template>
    <div style="max-width: 360px;" class="m-auto package-info-wrapper"
        v-bind:class="{ 'is-selected': request.packageId === element.id }">
        <div class="package-indicator-top d-flex flex-fill align-items-center justify-content-center w-100">
            <img style="height: 0.95rem" src="/logo/iRender-fulltext-white.svg" alt="" />
        </div>
        <el-card class="package-el-card" 
            v-bind:class="{ 'is-selected': request.packageId === element.id }"
            v-if="element" :style="`border: 2px solid ${request.packageId === element.id
                    ? '#64B5F6; border-radius: 0px'
                    : 'transparent; border-radius: 0.5rem'
                }`" 
                :body-style="{ padding: '5px 25px'}">
            <div class="package-item" style="font-family: Montserrat">
                <div>
                    <div class="
                            d-flex
                            flex-row
                            justify-content-between
                            align-items-center
                        " style="height: 2.6rem">
                        <div class="d-flex flex-row align-items-center" v-if="element.structuredName">
                            <div>
                                {{ element.structuredName.split("|")[0] }}
                            </div>
                            <div class=" d-flex align-items-center justify-content-center text-center ml-2 " 
                                v-if=" element.structuredName.split('|').length > 1 " 
                                style=" color: white; font-size: 0.85rem; background-color: #42a5f5; padding: 0 0.75rem; height: 1.6rem; border-radius: 0.7rem; ">
                                <span>{{
                                    element.structuredName.split("|")[1]
                                    }}</span>
                            </div>
                        </div>
                        <div class="d-flex flex-row align-items-center" v-else>
                            <div>
                                {{ element.name }}
                            </div>
                        </div>
                    </div>
                    <div style="height: 2.5rem" class="d-flex flex-row align-items-center">                        
                        <div class="d-flex flex-row align-items-center">
                            <div style=" color: #1976d2; font-size: 1.5rem; line-height: 2rem; font-weight: 700; ">
                                {{ element.priceBeforeDecimal }}.{{ element.priceAfterDecimal }}
                            </div>
                            <div class="ml-2" style="font-size: 0.9rem">
                                {{ $t('rentalInfo.pointLabel') }}/{{ $t('rentalInfo.hourLabel') }}
                            </div>
                            <div class="ms-2" v-if="showPriceAsVND"> 
                                ≈ {{ element.priceHour * 25000 | formatNumberVN}} VNĐ
                            </div>
                        </div>
                    </div>
                    <div v-if="showPriceAsVND"> 
                        <div class="text-center mt-1" 
                            style="max-width: 360px; color: white; font-size: 0.8rem; background-color: #66bb6a; padding: 0.2rem 1rem; border-radius: 1rem; ">
                            Dùng trên 3 giờ giảm 10%
                        </div>
                    </div>
                </div>
                <div style="font-size: 0.8rem" class="d-flex flex-column">
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot mr-2">•</div>
                        <div>
                            <span class="title-info">{{ $t('rentalInfo.gpuLabel') }}</span>
                            <span style="
                                    color: #388e3c;
                                    font-size: 1rem;
                                    font-weight: 700;
                                ">
                                <span>{{ element.numberCard }}</span>
                                <span style="font-size: 0.7rem" class="ml-1 mr-1">x</span>
                                <span>{{ element.detailGraphic }}</span>
                            </span>
                            <span class="ml-2" v-if="
                                cardInformation.find(
                                    (x) => x.id === element.detailGraphic
                                )
                            ">{{
                                    cardInformation.find(
                                        (x) => x.id === element.detailGraphic
                                    ).vram
                                }}
                                {{ $t('rentalInfo.vramSuffix') }}
                            </span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <el-tooltip :content="element.microarchitecture">
                            <div class="d-flex">
                                <span class="title-info">{{ $t('rentalInfo.microarchitectureLabel') }}</span>
                                <span><v-clamp autoresize :max-lines="1">{{ element.microarchitecture
                                        }}</v-clamp></span>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">{{ $t('rentalInfo.nvlinkLabel') }}</span>
                            <span v-if="element.nvlink" style="color: forestgreen; font-weight: 600">{{
                                element.isNvlinkInstalled ? $t('rentalInfo.available') : $t('rentalInfo.request')
                                }}</span>
                            <span v-else>{{ $t('rentalInfo.notAvailable') }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <el-tooltip :content="element.detailCpu">
                            <div class="d-flex">
                                <span class="title-info">{{ $t('rentalInfo.cpuLabel') }}</span>
                                <span><v-clamp autoresize :max-lines="1">{{ element.detailCpu }}</v-clamp></span>
                            </div>
                        </el-tooltip>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">{{ $t('rentalInfo.ramLabel') }}</span>
                            <span>{{ element.detailMemory }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">{{ $t('rentalInfo.ssdLabel') }}</span>
                            <span>{{ element.detailStorage }}</span>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div class="d-flex flex-row align-items-center">
                            <div class="title-info">{{ $t('rentalInfo.osLabel') }}</div>
                            <div v-if="element.enabledWindows" class="d-flex flex-row align-items-center mr-3">
                                <img style="height: 0.85rem" src="/os/1.svg" />
                                <div class="ml-1">{{ $t('rentalInfo.windows') }}</div>
                            </div>
                            <div v-if="element.enabledUbuntu" class="d-flex flex-row align-items-center">
                                <img style="height: 0.85rem" src="/os/2.svg" />
                                <div class="ml-1">{{ $t('rentalInfo.ubuntu') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-row align-items-center mt-2">
                        <div class="dot">•</div>
                        <div>
                            <span class="title-info">{{ $t('rentalInfo.supportLabel') }}</span>
                            <span>{{ element.detailSupport }}</span>
                        </div>
                    </div>
                </div>
                <div class="mt-3 ml-3" style="
                        font-size: 0.85rem;
                        width: 27.5rem;
                        height: 2rem;
                        color: darkorange;
                        font-weight: 600;
                    " v-if="element.id === '28'">
                    {{ $t('rentalInfo.transferFilesNote') }}
                </div>
                <div v-else class="mt-5 mb-1" style="height: 2rem">
                    <div class="
                            d-flex
                            flex-row
                            justify-content-start
                            align-items-center
                        " v-if="
                            element.supportSoftware &&
                            element.supportSoftware.split(',').length > 0
                        ">
                        <img :src="`/icon/${softwareItem}.svg`" class="ml-1 mr-1" style="height: 2rem"
                            :key="softwareItem" v-for="softwareItem in element.supportSoftware.split(
                                ','
                            )" />
                        <div class="
                                d-flex
                                flex-row
                                justify-content-center
                                align-items-center
                            " style="width: 3rem">
                            {{ $t('rentalInfo.etc') }}
                        </div>
                    </div>
                </div>
            </div>
        </el-card>
        <div class="package-indicator-bot d-flex flex-fill align-items-center justify-content-center w-100 ">
            <div style=" color: white; font-size: 0.85rem; font-weight: 500; font-family: Montserrat; ">
                {{ $t('rentalInfo.selectedBadge') }}
            </div>
        </div>
    </div>
</template>
<script>
// Constant
import { RENT_TYPE } from "@/constant/rental";
import { PRICE_UNIT } from "@/constant/fixedRental";
import base from "@/scripts/base";
const VUE_APP_CODE = process.env.VUE_APP_CODE;

export default {
    extends: base,

    data() {
        return {
            showPriceAsVND: VUE_APP_CODE === 'IRENDER_GPU_VN',
            rentType: RENT_TYPE,
            priceUnit: PRICE_UNIT,
        };
    },

    computed: {
        monthNames() {
            return this.$t('rentalInfo.monthNames');
        },
    },

    props: {
        element: {
            type: Object,
            default: null,
        },
        request: {
            type: Object,
            default: null,
        },
        type: {
            type: Number,
            default: null,
        },
    },
};
</script>